import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
	data() {
		return {
			//学生身份证组合
			idcards: '',
			textarea: '',
			// 当前页面
			currentPage: 1,
			//每页的数据
			pageLen: 15,
			//搜索学生的条件
			searchStudent: {
				name: '',
				company: '',
				phone: '',
				idcard: '',
				balance_egt: '',
				balance_elt: '',
			},
			//余额充值id
			AddstudentBalanceId: '',
			//余额充值的钱
			AddstudentBalanceBalance: '',
			multipleSelection: [],
			// 表单的对象绑定的值
			form: {
				name: "",
				idCard: "",
				phone: '',
				password: '',
				confirmPassword: '',
				company: '',
				email: '',
			},
			//辨别是用条件搜索还是全部搜索学生=>默认全部
			searchType: true,
			//学生总数量
			studentTotal: 0,
			//学生搜素当前页
			studentSearchCurrentPage: 0,
			//学生当前页
			studentCurrentPage: 0,
			//修改
			cer_year: '',
			//表单的样式宽度
			formLabelWidth: "120px",
			//学生数据
			studnetData: [],
			//弹出框的搜索字符串
			search: "",
			//批量充值弹框
			BalanceDialogVisible: false,
			//批量充值金额
			balance: '',
			//余额充值弹框
			BalanceDialog: false,
			//余额充值金额
			studentBalance: '',
			//余额充值确认弹框
			centerDialogVisible: false,
			//修改学员信息弹出框
			dialogUpdatetVisible: false,
			//绑定在输入框的学员信息
			stuInfo: {},
			//余额充值学生id
			BalanceStudentId: '',
			//根据身份证批量充值弹窗
			IdBalanceDialogVisible: false,

			//身份证批量充值金额
			IdStudentsBalance: '',
			//根据身份证批量充值确认弹窗
			IdCenterDialogVisible: false,
			//批量充值确认弹窗
			moreCenterDialogVisible: false,
			//余额更新弹窗数据
			studentBalanceUpdate: '',
			//余额更新弹窗
			BalanceUpdateDialog: false,
			// 用户当前余额
			oldBalance: '',
			// 身份证数组
			idcard_arr: [],
			// 修改余额备注
			note: '',
			// 下载批量充值模板
			downloadBatch: this.baseUrl + 'excel_template/batch-by-idcards.xlsx',
			// 是否现在加载中
			loading: false,
			//余额充值模板弹窗
			BatchDialog: false,
			errorMsg: [],
			// 导出显示加载中
			exportLoading: false,
			// 导出excel
			excelDialog: false,
			exceldata: {
				offset: 0,
				length: 0
			},
			balanceRecordDialog: false, //充值余额记录
			balanceRecordTable: [], //单个学员充值记录
			recordSelectType: ["余额充值", "余额支付", "取消余额支付订单", "取消郑州银行支付订单", "取消批量开课订单", "取消余额充值","余额退款"], // 余额充值类型
			recordType: '余额充值', //当前余额记录搜索类型
			balanceType: true, //true为余额充值，false为退款
		}
	},
	methods: {
		getBalanceRecordList() {
			console.log(this.multipleSelection)
			if (this.multipleSelection.length != 1) {
				this.$message.error('请选择一个学员')
				return;
			}
			let data = {
				token: this.$store.state.authority_management,
				offset: 0,
				length: 9999,
				user_id: this.multipleSelection[0].id
			}
			if (this.recordType) data.type = this.recordType
			this.$post('balance_record/search', data).then(res => {
				this.balanceRecordTable = res.data.result.data;
				this.balanceRecordDialog = true;
			})

		},
		//删除余额记录
		delectBalanceRecord(item) {
			console.log(item)
			this.$confirm(`此操作将取消这条余额为${item.total_fee}充值, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				console.log('this.multipleSelection[0].id', this.multipleSelection[0].id)
				this.$post('balance_record/cancelRecharge', {
					token: this.$store.state.authority_management,
					id: item.id,
					user_id: this.multipleSelection[0].id,
					type: item.type
				}).then(res => {
					console.log(res)
					if (res.data.status) {
						this.$message.success('操作成功');
						// this.getBalanceRecordList();
						this.getAllStudent();
						this.balanceRecordDialog = false;
					} else {
						this.$message.error('操作失败，请重试或联系技术')
					}
				}).catch(err => {
					this.$message.error('功能有误，请联系有关人员！！')
				})
			}).catch((error) => {
				console.log(error, 'error')
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		//上传批量余额注册
		uploadBatch(q) {
			this.errorMsg = []
			this.$upload(this.baseUrl + 'users/batchRechargeImport', q).then(res => {
				console.log(res)
				if (res.data.status == 'success') {
					this.$message({
						type: 'success',
						message: '充值成功'
					})
				} else {
					this.errorMsg = res.data.errorMsg
				}
			})

		},

		//余额更新弹窗确定按钮事件
		UpdateStudentBalanceSure() {
			this.$confirm('此操作将为该学生余额更新为：' + this.studentBalanceUpdate + '元, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// this.addBalance();
				this.updateBalance();

				// 插入余额日志
				// this.createLog()
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消操作'

				});
				// this.studentBalance = ''; 
			});
			// this.addBalance();

		},
		//余额更新弹窗取消按钮
		clearBalance4() {
			// this.studentBalanceUpdate = '';
			this.BalanceUpdateDialog = false;
			this.note = '';
		},
		//批量充值弹窗取消按钮
		clearBalance2() {
			this.BalanceDialogVisible = false
			this.balance = '';
			this.note = '';
			this.$refs.multipleTable.clearSelection();
		},
		//批量充值确认弹窗按钮
		moreCenterDialogSure() {
			this.$confirm(`此操作将为选中的学生进行${this.balanceType ? '余额充值' : '退款'}：${this.balance}元, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				if (this.balanceType) {
					this.Recharge();
				} else {
					this.balanceRefund()
				}
			}).catch((err) => {
				this.$message({
					type: 'info',
					message: '已取消操作'
				});
				// this.multipleSelection = '';
				this.balance = '';
				this.$refs.multipleTable.clearSelection();
			});

			// this.handleBalance();
			// this.balance = 222;
			this.moreCenterDialogVisible = false;
			this.BalanceDialogVisible = false;

		},

		// 余额退款
		balanceRefund() {
			// 储存已勾选的id
			let multipleSelectionID = [];
			for (var n = 0; n < this.multipleSelection.length; n++) {
				multipleSelectionID.push(this.multipleSelection[n].id);
			}
			this.multipleSelection = []

			// js对象转json数据
			let user_id_arr = JSON.stringify(multipleSelectionID);

			let data = {
				token: this.$store.state.authority_management,
				refund_total_fee: this.balance,
				user_id_arr,
				note: this.note,
			}

			this.$post('balance_record/balanceRefund', data).then(res => {
				console.log(res)
				if(res.data.status == 'success'){
					this.$message.success('操作成功')
				}else{
					this.$message.error('请重试')
				}
				// 重新加载数据
				this.getAllStudent();
				this.$refs.multipleTable.clearSelection();
				this.balance = '';
			}).catch((err)=>{
				this.$message.error(`${err},请联系技术人员`)
			})
			
			
			this.moreCenterDialogVisible = false;
			this.BalanceDialogVisible = false;
		},

		//批量充值弹窗事件
		handleBalance(type) {
			this.balanceType = type
			if (this.multipleSelection.length == 0) {
				this.$message({
					type: 'info',
					message: '您尚未勾选学员'
				});
			} else {
				this.BalanceDialogVisible = true;
			}

		},

		//身份证批量充值弹窗取消按钮
		clearBalance3() {
			this.IdBalanceDialogVisible = false;
			this.IdStudentsBalance = '';
			this.textarea = '';
			this.note = '';
		},
		//根据身份证批量充值按钮
		IdBalanceDialogSure() {
			if (this.checkAddBalanceByIdCards()) {
				// console.log(this.textarea);
				this.$confirm('此操作将为选中的学员进行余额充值：' + this.IdStudentsBalance + '元, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.addBalanceByIdCards();
					// this.$message({
					//   type: 'success',
					//   message: 'shnchu'
					// }); 
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
					this.IdStudentsBalance = '';
					this.textarea = '';
				});
			}


			// this.addBalanceByIdCards();
			// this.idcards = '';
			// this.IdStudentsBalance = '';

			// this.IdCenterDialogVisible = false;
		},
		//根据身份证批量充值验证
		checkAddBalanceByIdCards() {
			if (this.textarea.trim().length == 0) {
				this.$message({
					type: 'info',
					message: '你尚未输入学员身份证'
				});
				this.IdStudentsBalance = 0;
				return false;
			} else {
				return true;
			}
		},
		//根据身份证批量充值事件
		addBalanceByIdCards() {
			let temp = this.textarea.trim().split(/[\n]/g);
			let idcardReg =
				/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;


			for (var i = 0; i < temp.length; i++) {
				let idcard = temp[i];
				if (!idcardReg.test(idcard)) {
					this.$message({
						message: `身份证格式错误: 【${idcard}】`,
						type: 'error'
					});
					break;
				}
			}
			if (i == (temp.length)) {
				// 赋值给idcard_arr，在批量充值的时候可作为参数插入到余额日志表
				this.idcard_arr = temp
				// console.log('校验完毕');
				let temp2 = JSON.stringify(temp);
				// console.log(temp2);
				let data = {
					idCard_arr: temp2,
					token: this.$store.state.authority_management,
					money: this.IdStudentsBalance,
					note: this.note,
				}
				let consumption = this.IdStudentsBalance
				this.$post('users/batchRechargeByIdcard', data).then(res => {
					console.log(res)
					if (res.data.status == 'success') {
						this.$message({
							message: '充值成功',
							type: 'success'
						});

						// 重新加载数据
						this.getAllStudent();
						this.textarea = '';
						this.IdStudentsBalance = '';

						// 插入用户余额日志表
						this.insertLog(consumption)
					} else {
						// this.$message({
						//     message: '充值失败',
						//     type: 'error'
						// });
						alert(res.data.errorMsg.msg + res.data.errorMsg.idCard)
					}
					this.note = '';

				}).catch(err => {
					this.$message({
						message: '充值失败,请重试',
						type: 'error'
					});
				})
				this.IdBalanceDialogVisible = false;
				this.textarea = '';
				this.IdStudentsBalance = '';
			}


		},
		//根据身份证充值按钮
		IdBalanceDialog() {
			this.IdBalanceDialogVisible = true;
		},

		//学生余额充值事件
		addBalance() {
			let data = {
				id: this.AddstudentBalanceId,
				token: this.$store.state.authority_management,
				balance: Number.parseInt(this.studentBalance) + Number.parseInt(this.AddstudentBalanceBalance),
			}
			this.$post('users/balance', data).then(res => {
				// console.log(res.data.status)
				if (res.data.status == 'success') {
					this.$message({
						message: '充值成功',
						type: 'success'
					});
					// 重新加载数据
					this.getAllStudent();

				} else {
					// console.log('错误' + res.data.message);
					this.$message({
						message: '充值失败',
						type: 'error'
					});
				}
			})
			this.studentBalance = 0;
		},
		//学生余额更新事件
		updateBalance() {
			let data = {
				id: this.AddstudentBalanceId,
				token: this.$store.state.authority_management,
				balance: Number.parseInt(this.studentBalanceUpdate),
				note: this.note
			}
			this.$post('users/balance', data).then(res => {
				// console.log(res.data.status)
				if (res.data.status == 'success') {
					this.$message({
						message: '更新成功',
						type: 'success'
					});
					// 重新加载数据
					this.getAllStudent();

				} else {
					// console.log('错误' + res.data.message);
					this.$message({
						message: '更新失败',
						type: 'error'
					});
				}
			})
			this.BalanceUpdateDialog = false;
			this.note = '';
		},

		//余额充值弹窗
		AddstudentBalance(id, balance) {
			// console.log(obj);
			this.AddstudentBalanceId = id;
			this.AddstudentBalanceBalance = balance;
			this.BalanceDialog = true;
			this.BalanceStudentId = id;

		},
		//余额更新弹窗
		updateStudentBalance(id, balance) {
			// console.log(obj);
			this.AddstudentBalanceId = id;
			this.studentBalanceUpdate = balance;
			this.BalanceUpdateDialog = true;
			this.BalanceStudentId = id;

			// 获取到用户当前的余额
			this.oldBalance = balance
		},

		//余额充值弹窗取消按钮
		clearBalance() {
			this.BalanceDialog = false;
			this.studentBalance = '';
			this.note = '';
		},

		//余额充值确定弹窗确定按钮
		AddstudentBalanceSure() {
			this.$confirm('此操作将为该学生进行余额充值：' + this.studentBalance + '元, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.addBalance();

			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'

				});
				this.studentBalance = '';
			});
			// this.addBalance();

			this.BalanceDialog = false;
		},

		//表格选择
		handleTableSelectionChange(val) {
			this.multipleSelection = val;
		},
		//批量充值
		Recharge() {
			// 判断已勾选数组是否为空
			if (this.multipleSelection.length !== 0) {
				// 储存已勾选的id
				let multipleSelectionID = [];
				for (var n = 0; n < this.multipleSelection.length; n++) {
					multipleSelectionID[n] = JSON.parse(this.multipleSelection[n].id);
				}
				this.multipleSelection = []

				// js对象转json数据
				let last = JSON.stringify(multipleSelectionID);
				// console.log(last);
				// onsale为1代表上架商品
				let data = {
					user_id_arr: last,
					money: this.balance,
					token: this.$store.state.authority_management,
					note: this.note,
				}
				let balance = this.balance
				this.$post('users/batchRechargeByUserId', data).then(res => {
					// console.log(res)
					if (res.data.status = 'success') {
						this.$message({
							message: '充值成功',
							type: 'success'
						});
						// 重新加载数据
						this.getAllStudent();

						// 调用根据id批量将数据插入用户余额日志表
						this.insertLog2(multipleSelectionID, balance)
					} else {
						this.$message({
							message: '充值失败',
							type: 'warning'
						});
					}
					this.BalanceDialogVisible = false;
					this.note = '';

				})
			}
			this.$refs.multipleTable.clearSelection();
			this.balance = '';

		},
		//该页每页要的数组
		handleSizeChange(val) {
			this.pageLen = val;
			this.getAllStudent();
		},

		//确定搜索学生
		confirmSearch() {
			this.currentPage = 1
			this.searchType = false;
			this.studentCurrentPage = 0;
			let obj = {
				token: this.$store.state.authority_management,
				company: this.searchStudent.company,
				name: this.searchStudent.name,
				phone: this.searchStudent.phone,
				idcard: this.searchStudent.idcard,
				balance_egt: this.searchStudent.balance_egt,
				balance_elt: this.searchStudent.balance_elt,
				offset: this.studentCurrentPage,
				length: this.pageLen,
				shop_id: this.$store.state.store.id
			};
			this.$post('users/search', obj).then(res => {
				this.studnetData = res.data.result.data;
				this.studentTotal = res.data.result.total;
			})
		},
		//点击当前页面获取该有的信息
		getClassPage(currentPage) {
			this.classCurrentPage = (currentPage - 1) * 15;
			// this.allClass(this.studentId);
		},
		//获取所有学生的信息
		getAllStudent() {
			this.searchType = true;
			this.$post('users/search', {
				token: this.$store.state.authority_management,
				offset: this.studentCurrentPage,
				length: this.pageLen,
				shop_id: this.$store.state.store.id,
				company: this.searchStudent.company,
				name: this.searchStudent.name,
				phone: this.searchStudent.phone,
				idcard: this.searchStudent.idcard,
				balance_egt: this.searchStudent.balance_egt,
				balance_elt: this.searchStudent.balance_elt,
			}).then(res => {
				this.studentTotal = res.data.result.total;
				this.studnetData = res.data.result.data;
			})
		},
		//根据分页获取学生信息
		getStudentPage(currentPage) {
			this.currentPage = currentPage;
			if (this.searchType) {
				//根据点击的分页改变数据的偏移量
				this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
				//再请求对应的学生信息
				this.getAllStudent();
			} else {
				this.studentCurrentPage = (Number.parseInt(currentPage) - 1) * 15;
				this.confirmSearch()
			}

		},

		// 插入用户余额更改记录到用户余额日志表
		// createLog() {
		//     let upBanlance = this.studentBalanceUpdate - this.oldBalance
		//     let upBanlanceString = ''
		//     if (this.oldBalance < this.studentBalanceUpdate) {
		//         upBanlanceString = '存入' + Math.abs(upBanlance) + '元'
		//     } else {
		//         upBanlanceString = '支出' + Math.abs(upBanlance) + '元'
		//     }
		//     this.$post('user_log/create_by_userid', {
		//         count: Math.abs(upBanlance),
		//         user_id: this.BalanceStudentId,
		//         content: upBanlanceString,
		//         balance: this.studentBalanceUpdate,
		//         shop_id: this.$store.state.store.id
		//     })
		//     this.BalanceDialog = false;
		//     this.BalanceUpdateDialog = false;
		// },

		/**
		 * 根据身份证将充值记录批量插入用户余额日志表
		 * @param {*} consumption 本次批量充值的金额
		 */
		insertLog(consumption) {
			//   console.log('consumption', consumption)
			let idcard_arr = this.idcard_arr
			let id_arr = []
			//   console.log(idcard_arr)
			// 发送请求，根据身份证获取id
			this.$post('users/idcard_arr_id', {
				idcard_arr: JSON.stringify(idcard_arr),
				token: this.$store.state.authority_management,
				offset: 0,
				length: 99999,
				shop_id: this.$store.state.store.id
			}).then(res => {
				if (res.status === 200) {
					res.data.result.data.map(item => {
						id_arr.push(item.id)
					})
					//   console.log(JSON.stringify(id_arr))
					// 根据id获取余额
					id_arr.map(id => {
						this.$post('users/get_balance', {
							id: id,
							token: this.$store.state.authority_management
						}).then(res => {
							if (res.status === 200) {
								// console.log('res.data.result.balance', res.data.result.balance)
								this.createLogById(id, res.data.result.balance, consumption)
							}
						})
					})
				}
			})
		},

		/**
		 * 根据id将充值记录批量插入用户余额日志表
		 * @param {*} id_arr 用户id数组
		 * @param {*} consumption 本次充值金额
		 */
		insertLog2(id_arr, consumption) {
			//   console.log('id_arr', id_arr)
			id_arr.map(id => {
				this.$post('users/get_balance', {
					id: id,
					token: this.$store.state.authority_management
				}).then(res => {
					if (res.status === 200) {
						// console.log('res.data.result.balance', res.data.result.balance)
						this.createLogById(id, res.data.result.balance, consumption)
					}
				})
			})
		},

		/**
		 * 将用户充值余额记录插入到用户余额日志表
		 * @param {*} userId 用户id
		 * @param {*} balance 充值成功后的余额
		 * @param {*} consumption 本次批量充值的金额
		 */
		createLogById(userId, balance, consumption) {
			//   console.log('consumption', consumption)
			this.$post('user_log/create_by_userid', {
				count: consumption,
				user_id: userId,
				content: '存入' + consumption + '元',
				balance: Number(balance),
				shop_id: this.$store.state.store.id
			})
		},


		// 导出excel
		exportExcel() {
			this.excelDialog = true;
		},

		// 确认导出
		confirmexport() {
			this.exportLoading = true;
			this.excelDialog = false;
			let data = {
				token: this.$store.state.authority_management,
				offset: this.exceldata.offset,
				length: this.exceldata.length
			}
			if (this.searchStudent.name) {
				data.name = this.searchStudent.name
			}
			if (this.searchStudent.company) {
				data.company = this.searchStudent.company
			}
			if (this.searchStudent.phone) {
				data.phone = this.searchStudent.phone
			}
			if (this.searchStudent.idcard) {
				data.idcard = this.searchStudent.idcard
			}
			if (this.searchStudent.balance_egt) {
				data.balance_egt = this.searchStudent.balance_egt
			}
			if (this.searchStudent.balance_elt) {
				data.balance_elt = this.searchStudent.balance_elt
			}

			this.$post('users/balanceExport', data).then(res => {
				this.exportLoading = false;
				window.open(res.data.result)
			})
		},

		// 在输入框输入数据时触发
		inputNumber(e) {
			e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
		},

		//打开批量充值模板
		openBacthDialog() {
			this.BatchDialog = true;
			this.errorMsg = [];
		},
		// 下载批量充值模板
		handleDownloadBatch() {
			let a = document.createElement('a');
			a.setAttribute('href', this.downloadBatch);
			a.setAttribute('download', this.downloadBatch);
			a.click();
		}
	},
	filters: {
		tagFilter(value) {
			let type = 'danger'
			if (value == '否') type = 'success'
			return type
		}
	},
	created() {
		this.getAllStudent();
	}

}
